<template>
  <div>
    <div class="chart-toolbar">
      <select v-model="direction" @change="reRenderChart">
        <option value="t2b">Top to Bottom</option>
        <option value="b2t">Bottom to Top</option>
        <option value="l2r">Left to Right</option>
        <option value="r2l">Right to Left</option>
      </select>
      <button @click="expandAll">Expand All</button>
      <button @click="collapseAll">Collapse All</button>
      <button @click="exportToPDF" :disabled="!userHasExportPermission">Export as PDF</button>
    </div>
    <div id="chart-container" ref="chartContainer"></div>
  </div>
</template>

<script>
export default {
  name: 'OrgChart',
  props: {
    userHasExportPermission: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      direction: 't2b',
      chartInstance: null,
      orgData: null
    };
  },
  async mounted() {
    await this.loadOrgChartAssets();
    await this.fetchOrgChartData();
    this.assignLevels(this.orgData);
    this.initChart();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.$chartContainer.remove();
      this.chartInstance = null;
    }
    Array.from(document.querySelectorAll('style[id^="org-level-"]')).forEach(el => el.remove());
  },
  methods: {
    async loadOrgChartAssets() {
      const loadScript = src => new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve(script);
        script.onerror = reject;
        document.head.appendChild(script);
      });

      const loadStyle = href => new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.href = href;
        link.rel = 'stylesheet';
        link.onload = () => resolve(link);
        link.onerror = reject;
        document.head.appendChild(link);
      });

      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js');
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/orgchart/2.1.3/js/jquery.orgchart.min.js');
      await loadStyle('https://cdnjs.cloudflare.com/ajax/libs/orgchart/2.1.3/css/jquery.orgchart.min.css');
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
    },

    async fetchOrgChartData() {
      try {
        // const res = await fetch('/api/orgchart');
        // this.orgData = await res.json();
        this.orgData = {
          'name': 'Radha Krishna All',
          'title': 'CEO',
          "img": '',
          'children': [
            {
              'name': 'Amarendra Kotipalli',
          'title': 'Project Manager',
          "img": '',
          'children': [
            {
              'name': 'Ravi Teppala', 'title': 'Tech Lead',
              "img": 'https://i.pravatar.cc/100?img=2',
              'children': [
                {
                  'name': 'SaiKumar Barla',
                  "img": 'https://i.pravatar.cc/100?img=13', 'title': 'Senior Engineer', 
                },
                {
                  'name': 'Durga Dileep',
                  "img": 'https://i.pravatar.cc/100?img=14', 'title': 'Senior Engineer', 
                  'children': [
                    {
                      'name': 'Keerthana Ch',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'Jr Engineer', 
                    },
                    {
                      'name': 'Shivani Gollapalli',
                      "img": 'https://i.pravatar.cc/100?img=16', 'title': 'Jr Engineer', 
                    },
                  ]
                },
                
                {
                  'name': 'Vibhakar Vaddi',
                  "img": 'https://i.pravatar.cc/100?img=14', 'title': 'Senior Engineer', 
                  'children': [
                    {
                      'name': 'Sravani Ambati',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'Jr Engineer', 
                    },
                    {
                      'name': 'Laxmi Majjiga',
                      "img": 'https://i.pravatar.cc/100?img=16', 'title': 'Jr Engineer', 
                    },
                  ]
                },
                {
                  'name': 'Tharuni Seru',
                  "img": 'https://i.pravatar.cc/100?img=14', 'title': 'Senior Engineer', 
                  'children': [
                    {
                      'name': 'Mukesh Kumar',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'UI Engineer', 
                    },
                    {
                      'name': 'Kavya Kalidasu',
                      "img": 'https://i.pravatar.cc/100?img=16', 'title': 'Jr Engineer', 
                    },
                  ]
                },
                
                {
                  'name': 'Prasanna Challagali',
                  "img": 'https://i.pravatar.cc/100?img=14', 'title': 'Senior Engineer', 
                  'children': [
                    {
                      'name': 'Arshiya Shaik',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'Jr Engineer', 
                    }
                  ]
                }
                ,
                {
                  'name': 'Swarna Bese',
                  "img": 'https://i.pravatar.cc/100?img=14', 'title': 'Senior Engineer', 
                  'children': [
                    {
                      'name': 'Naga Manikanta',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'Jr Engineer', 
                    },
                    {
                      'name': 'Padmavathi Gajulaplli',
                      "img": 'https://i.pravatar.cc/100?img=16', 'title': 'Jr Engineer', 
                    },
                  ]
                },

              ]

            },
            {
              'name': 'Neeharika Shabadhu', 'title': 'QA Lead',
              "img": 'https://i.pravatar.cc/100?img=2',
              'children': [
                {
                  'name': 'Balakrishna Takasi',
                  "img": 'https://i.pravatar.cc/100?img=13', 'title': 'Sr QA Engineer', 
                },
                {
                  'name': 'UshaRani Alla',
                  "img": 'https://i.pravatar.cc/100?img=13', 'title': 'Sr QA Engineer', 
                },
                {
                  'name': 'Balakrishna Takasi',
                  "img": 'https://i.pravatar.cc/100?img=13', 'title': 'Sr QA Engineer', 
                  'children': [
                    {
                      'name': 'Akhil Orusu',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'Jr QA Engineer', 
                    },
                    {
                      'name': 'Akhil Pachipala',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'Jr QA Engineer', 
                    },
                    {
                      'name': 'Meghana Q',
                      "img": 'https://i.pravatar.cc/100?img=17', 'title': 'Jr QA Engineer', 
                    }
                  ]
                }
              ]
            },
            {
              'name': 'Murtaza', 'title': 'BA Lead',
              "img": 'https://i.pravatar.cc/100?img=2',
              'children': [
                {
                  'name': 'Madurima Akula',
                  "img": 'https://i.pravatar.cc/100?img=13', 'title': 'Sr BA', 
                  'children': [
                    {
                      'name': 'Sahil Tota',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'BA', 
                    },
                    {
                      'name': 'Sahithi',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'BA', 
                    }]
                },
                {
                  'name': 'Gayatri patro',
                  "img": 'https://i.pravatar.cc/100?img=13','title': 'Sr BA', 
                  'children': [
                    {
                      'name': 'Manasa D',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'BA', 
                    },
                    {
                      'name': 'Manoj Konda',
                      "img": 'https://i.pravatar.cc/100?img=15', 'title': 'BA', 
                    }]
                },
                {
                  'name': 'Venkatesh Kadiri',
                  "img": 'https://i.pravatar.cc/100?img=13', 'title': 'BA', 
                  'children': [
                    {
                      'name': 'Suma Talluri',
                      "img": 'https://i.pravatar.cc/100?img=15',  'title': 'BA', 
                    },
                    {
                      'name': 'Akhifa Sultana',
                      "img": 'https://i.pravatar.cc/100?img=15',  'title': 'BA', 
                    },
                    {
                      'name': 'Meghana Q',
                      "img": 'https://i.pravatar.cc/100?img=17',  'title': 'BA', 
                    }
                  ]
                }
              ]
            },
          ]
            },
            {
              'name': 'Mohith Sharma',
              "img": 'https://i.pravatar.cc/100?img=18', 'title': 'PMO -AI & Connector IO', 
              'children': [
                {
                  'name': 'Vinay Ponnaganthi',
                  "img": 'https://i.pravatar.cc/100?img=19', 'title': 'AI Trainee', 
                  'children': [
                    {
                      'name': 'Durga Prasad',
                      "img": 'https://i.pravatar.cc/100?img=31', 'title': 'Jr Engineer', 
                    },
                    {
                      'name': 'Jyothi N',
                      "img": 'https://i.pravatar.cc/100?img=41', 'title': 'Jr Engineer', 
                    },
                    {
                      'name': 'Anusha Nulakana',
                      "img": 'https://i.pravatar.cc/100?img=51', 'title': 'Sr Engineer', 
                    }
                  ]
                },
                {
                  'name': 'BheemaSankar Mogali',
                  "img": 'https://i.pravatar.cc/100?img=21', 'title': 'Sr Engineer', 
                  'children': [
                    {
                      'name': 'Reeshma Gumadi',
                      "img": 'https://i.pravatar.cc/100?img=31', 'title': 'Jr Engineer', 
                    },
                    {
                      'name': 'Sai Durga',
                      "img": 'https://i.pravatar.cc/100?img=41', 'title': 'Jr Engineer', 
                    },
                    {
                      'name': 'BalaGayathri M',
                      "img": 'https://i.pravatar.cc/100?img=51', 'title': 'Sr Engineer', 
                    }
                  ]
                }
              ]
            }
          ]
        };
        this.assignLevels(this.orgData);
      } catch (err) {
        alert('Failed to fetch org chart data.');
        console.error(err);
      }
    },
    getInitials(fullName) {
      const parts = fullName.trim().split(/\s+/);
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
      if (parts.length === 2) return parts.map(p => p.charAt(0).toUpperCase()).join('');
      return parts[0].charAt(0).toUpperCase() + parts[1].charAt(0).toUpperCase() + parts[2].charAt(0).toUpperCase();
    },
    injectDynamicLevelStyle(level, hueBase = 360) {
      const className = `KF-level-${level}`;
      if (document.getElementById(className)) return;
      const hue = (level * 47) % hueBase;             // Slightly prime multiplier to avoid patterns
      const saturation = 65 + (level % 3) * 5;         // Between 65–75%
      const lightness = 48 + (level % 2) * 6;          // Between 48–54%

      const bg = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      const border = `hsl(${hue}, ${saturation}%, ${lightness - 10}%)`;

      const style = document.createElement('style');
      style.id = className;
      style.textContent = `
    .orgchart .${className} .title {
      background-color: ${bg} !important;
    }
    .orgchart .${className} .content {
      border-color: ${border} !important;
    }
  `;
      document.head.appendChild(style);
    },

    assignLevels(node, level = 0) {
      node._level = level;
      if (Array.isArray(node.children)) {
        node.children.forEach(child => this.assignLevels(child, level + 1));
      }
    },
    initChart() {
      const $ = window.jQuery;
      $(this.$refs.chartContainer).orgchart({
        data: this.orgData,
        direction: this.direction, // 👈 Choose: 't2b', 'b2t', 'l2r', or 'r2l'
        nodeContent: 'title',
        draggable: true,
        pan: true,
        createNode: ($node, data) => {
          const level = data._level || 0;
          const hueBase = ((level + 1) * 60) % 360;
          const className = `KF-level-${level}`;

          const hue = (level * 47) % hueBase;
          const saturation = 65 + (level % 3) * 5;
          const lightness = 48 + (level % 2) * 6;

          this.injectDynamicLevelStyle(level, hueBase);
          $node.addClass(className); // Add class to root node wrapper

          const rotation = this.getAvatarRotation(this.direction);
          const avatarClass = `avatar image-avatar rotate-${this.direction}`;

          let avatarHTML = '';
          if (data.img && data.img.trim()) {
            avatarHTML = `<img class="${avatarClass}" src="${data.img}" alt="${data.name}" style="transform: rotate(${rotation});width:40px;height:40px;border-radius:50%;margin-bottom:4px;" />`;
          } else {
            const initials = this.getInitials(data.name);
            avatarHTML = `<div style="with:100%;text-align:center;"><div class="avatar initials-avatar rotate-${this.direction}" style="transform: rotate(${rotation}); width:40px;height:40px;border-radius:50%;margin-bottom:4px;background-color: hsl(${hue}, ${saturation}%, ${lightness - 10}%) !important;  border: 1px solid hsl(${hue}, ${saturation}%, ${lightness}%) !important;display: inline-block;">
             <p class="circle-inner" style="color: white;display: table-cell;vertical-align: middle;text-align: center;text-decoration: none;height: 40px;width: 40px;font-size: 16px;"> ${initials}</p>
              </div></div>`;
          }

          const wrapper = document.createElement('div');
          wrapper.className = 'node-wrapper';
          wrapper.innerHTML = avatarHTML + $node.html();
          $node.html(wrapper);

          // $node.prepend(avatarHTML);
          $node.css({ opacity: 0 }).animate({ opacity: 1 }, 400);
        }
      });

      // this.chartInstance = chart.data('orgchart');

      // $(this.$refs.chartContainer).on('nodedrop.orgchart', () => {
      //   const updatedHierarchy = this.chartInstance.getHierarchy();
      //   console.log('Updated hierarchy:', updatedHierarchy);
      //   this.sendHierarchyToApi(updatedHierarchy);
      // });

      const chartEl = this.$refs.chartContainer.querySelector('.orgchart');
      if (chartEl) {
        this.chartInstance = $(chartEl).data('orgchart');
        console.log("Chart", this.chartInstance)

        $(chartEl).on('nodedrop.orgchart', (event, extraParams) => {
          console.log("Drop",event, extraParams)
          // const updatedHierarchy = this.chartInstance.getHierarchy();
          // console.log('Updated hierarchy:', updatedHierarchy);
          console.log('Dragged Node:', extraParams.draggedNodeData);
          console.log('Dropped Under:', extraParams.dropZoneNodeData);
          // this.sendHierarchyToApi(updatedHierarchy, extraParams);
        });
      }
    },
    getAvatarRotation(direction) {
      switch (direction) {
        case 'r2l':
          return '-90deg';
        case 'l2r':
          return '-90deg';
        case 'b2t':
          return '180deg';
        case 't2b':
        default:
          return '0deg';
      }
    },

    async sendHierarchyToApi(data) {
      try {
        await fetch('/api/orgchart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });
        alert('Hierarchy updated successfully.');
      } catch (err) {
        alert('Failed to update hierarchy.');
        console.error(err);
      }
    },

    expandAll() {
      if (this.chartInstance) this.chartInstance.expandAll();
    },

    collapseAll() {
      if (this.chartInstance) this.chartInstance.collapseAll();
    },

    async exportToPDF() {
      if (!this.userHasExportPermission) {
        alert('You do not have permission to export.');
        return;
      }

      const html2canvas = window.html2canvas;
      const { jsPDF } = window.jspdf;

      const chartEl = this.$refs.chartContainer;
      const originalTransform = chartEl.style.transform;
      chartEl.style.transform = 'scale(1)';

      const canvas = await html2canvas(chartEl, {
        scrollY: -window.scrollY,
        useCORS: true
      });

      const pdf = new jsPDF('landscape', 'pt', [canvas.width, canvas.height]);
      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);

      const blob = pdf.output('blob');
      const formData = new FormData();
      formData.append('file', blob, 'orgchart.pdf');

      try {
        const response = await fetch('/api/upload', {
          method: 'POST',
          body: formData
        });
        const result = await response.json();
        alert('PDF uploaded to S3 successfully.');
        console.log('S3 Upload Result:', result);
      } catch (error) {
        alert('Failed to upload PDF.');
        console.error(error);
      }

      chartEl.style.transform = originalTransform;
    },
    reRenderChart() {
      window.jQuery(this.$refs.chartContainer).empty();
      this.initChart();
    },
    adjustAlignment(direction) {
      const container = this.$refs.chartContainer;
      switch (direction) {
        case 'l2r':
          container.style.textAlign = 'left';
          break;
        case 'r2l':
          container.style.textAlign = 'right';
          break;
        case 't2b':
        case 'b2t':
        default:
          container.style.textAlign = 'center';
      }
      this.$nextTick(() => {
        const chartEl = container.querySelector('.orgchart');
        if (chartEl) {
          chartEl.style.margin = '0 auto';
        }
      });
    }

  }
};
</script>

<style>
.orgchart {
  background: #fff !important;
  
  .l2r,.r2l
  {
    position: unset;
  }
}
</style>

<style scoped>
/* #chart-container {
  font-family: Arial;
  height: 80vh;
  border: 2px dashed #aaa;
  border-radius: 5px;
  overflow: auto;
  text-align: center;
} */

#chart-container {
  font-family: Arial;
  /* min-height: 80vh; */
  border: 2px solid #aaaaaa68;
  border-radius: 5px;
  overflow: scroll !important;
  padding: 20px;
  white-space: nowrap;
  text-align: center;
}


.orgchart td.left,
.orgchart td.right,
.orgchart td.top {
  border-color: #aaa;
}

.orgchart td>.down {
  background-color: #aaa;
}

.chart-toolbar {
  margin-bottom: 10px;
  text-align: right;
}

.chart-toolbar button {
  margin-left: 10px;
  padding: 6px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.chart-toolbar button[disabled] {
  background-color: #ccc;
  cursor: not-allowed;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
}

.image-avatar {
  object-fit: cover;
}

.initials-avatar {
  background-color: #999;
  color: white;
}
</style>
